import React from 'react';
type SiteLogoProps = {
  size?: 'sm' | 'md';
};
export function SiteLogo({
  size = 'md'
}: SiteLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/jFDqgwrtPf1mNV3AVm5Aig/image.png" alt="Twenty Mile House, established 1854" className={`block h-auto ${size === 'sm' ? 'w-32' : 'w-40 md:w-48'}`} data-id="element-62" data-mp="36qka0u1n60ta" />;
}